import React from 'react'
import { useTranslation } from 'react-i18next'
import { Avatar, Box, Text } from '@node-space/ui-components'

interface ContactCardProps {
  name: string
}

export const ContactCard = ({ name }: ContactCardProps) => {
  const { t } = useTranslation()

  return (
    <Box background="subtle" flexCol width="full" paddingX={12} className="py-[10px]" gapY={4}>
      <Text color="subdued">{t('contacts.cryptoContact')}</Text>
      <Box flex align="center" gapX={4}>
        <Avatar size="small" type="entity" name={name ? name.charAt(0).toUpperCase() : ''} />
        <Text variant="body-label">{name}</Text>
      </Box>
    </Box>
  )
}
